import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from './Select';
import Checkbox from './Checkbox';

const Inputs = (props) => {
    const {
        label, type, error, params, placeholder, classes, setRef, onChange, labelClasses
    } = props;

    let inputField = <input ref={setRef} {...params} type={type} placeholder={placeholder} className={classes} onChange={onChange} />;

    switch (type) {
        case 'select':
            inputField = <Select {...params} onChange={onChange} />;
            break;
        case 'checkboxgroup':
            inputField = <Checkbox {...params} onChange={onChange} />;
            break;
        default:
            break;
    }

    return (
        <div className="form-field">
            {label ? <label className={labelClasses}>{label}</label> : null}
            <div className="input-field">
                {inputField}
                { error && <label className="error">{error}</label>}
            </div>
        </div>
    );
};

Inputs.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    type: PropTypes.string.isRequired,
    error: PropTypes.string,
    params: PropTypes.object,
    placeholder: PropTypes.string,
    classes: PropTypes.string,
    onChange: PropTypes.func,
};

Inputs.defaultProps = {
    label: null,
    placeholder: null,
    params: {},
    classes: null,
    onChange: () => {},
};

export default Inputs;
